import React from 'react';

const IconMedium = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1770 1000">
    <circle cx="500" cy="500" r="500"/>
    <ellipse ry="475" rx="250" cy="501" cx="1296"/>
    <ellipse cx="1682" cy="502" rx="88" ry="424"/>
  </svg>
  
);

export default IconMedium;

// BELOW IS THE OLD MEDIUM LOGO OFFICIATED BY THEM

// const IconMedium = () => (
//     <svg
//     xmlns="http://www.w3.org/2000/svg"
//     role="img"
//     viewBox="0 0 256 256"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     className="feather feather-medium">
//     <title>Medium</title>
//     <rect x="0" y="0" width="256" height="256" rx="5" ry="5"></rect>
//     <path d="M61.09 85.62c.21-2.11-.59-4.2-2.17-5.62L42.87 60.65V57.76h49.86l38.54 84.52 33.88-84.52h47.53v2.89L198.95 73.82c-1.18.9-1.77 2.38-1.53 3.85v96.72c-.25 1.47.35 2.95 1.53 3.85l13.41 13.16v2.89h-67.44v-2.89l13.89-13.48c1.36-1.36 1.36-1.76 1.36-3.85V95.89l-38.62 98.09h-5.22l-44.96-98.09v65.74c-.37 2.76.55 5.55 2.5 7.55l18.06 21.91v2.89H40.7v-2.89l18.06-21.91c1.93-2 2.8-4.8 2.34-7.54V85.62z"></path>
// </svg>


// );
